import React from 'react';

const Header = () => {
    return (
        <header>
            <h4>Add contact</h4>
        </header>
    );
};

export default Header;
